import WeekColumnHeader from './WeekColumnHeader';

export default WeekColumnHeader;
